import { render, staticRenderFns } from "./PwResetBox.vue?vue&type=template&id=584a9b00&"
import script from "./PwResetBox.vue?vue&type=script&lang=js&"
export * from "./PwResetBox.vue?vue&type=script&lang=js&"
import style0 from "./PwResetBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports